import App from './App.vue'
import adminRouter from '@/router/admin'
import businessRouter from '@/router/business'
import AppService from './service/AppService'
import RouterService from './pk/src/service/RouterService'
import './service/ValidateServiceFill'

RouterService.init(process.env.VUE_APP_PLATFORM === 'ADMIN' ? adminRouter : businessRouter);
(new AppService(App)).createApp(process.env.VUE_APP_PLATFORM === 'ADMIN' ? adminRouter : businessRouter)
